import React from "react";
import Nav from "react-bootstrap/esm/Nav";
import RBNavbar from "react-bootstrap/esm/Navbar";
import DirectionEnum from "../../enums/direction.enum";
import OrientationEnum from "../../enums/orientation.enum";
import ShadesEnum from "../../enums/shades.enum";
import classMap from "../../helpers/classMap";
import NavbarItemProps from "./navbar-item.props";
import NavbarProps from "./navbar.props";
import "./navbar.scss";

const Navbar = (props: NavbarProps) => {
  const {
    id,
    items,
    color,
    className,
    sectionsClassName,
    orientation,
    variant,
    fixed,
    addColumnClass,
    gap,
    sectionGap
  } = props;

  const flexDirection = orientation === OrientationEnum.VERTICAL ? "column" : "row";
  const fixedClassName = fixed ? `nav-fixed-${fixed}` : "";
  const colorClassName = color ? `bg-${color}` : "";

  interface ChildrenByDirectionProps {
    start: NavbarItemProps[];
    center: NavbarItemProps[];
    end: NavbarItemProps[];
  }
  const childrenByDirection: ChildrenByDirectionProps = {
    start: [],
    center: [],
    end: []
  };
  items.forEach((childProps: NavbarItemProps) =>
    childrenByDirection[childProps.direction || DirectionEnum.END].push(childProps)
  );
  const content =
    items.length &&
    Object.values(DirectionEnum).map((direction: string, directionIndex: number) => (
      <Nav
        key={directionIndex}
        className={classMap("mpng-navbar-items", addColumnClass ? "col" : "")}
        style={{
          gap: gap || "0px",
          flexDirection: flexDirection,
          justifyContent: direction
        }}
      >
        {(childrenByDirection as any)[direction].map((childProps: NavbarItemProps, index: number) => (
          <div key={index}>{childProps.item}</div>
        ))}
      </Nav>
    ));

  return (
    <RBNavbar
      id={id}
      variant={variant || ShadesEnum.LIGHT}
      className={classMap("mpng-ux-navbar", className, fixedClassName, colorClassName)}
      style={{ flexDirection: flexDirection }}
      as={undefined}
      ignore="1"
    >
      <div
        className={classMap("mpng-navbar-sections", sectionsClassName)}
        style={{ gap: sectionGap || "0px", flexDirection: flexDirection }}
      >
        {content}
      </div>
    </RBNavbar>
  );
};

export default Navbar;
